<app-navbar style="display:block;height:57px;" *ngIf="showHeader()"></app-navbar>
<router-outlet></router-outlet>
<app-footer></app-footer>
<!-- <ngx-scrolltop></ngx-scrolltop> -->
<app-alert></app-alert>